module.exports = __webpack_public_path__ + "media/store/images/calendar-05503a61d30239774c79b17aa5771484.svg";